module.exports = __webpack_public_path__ + "img/IMG_2541.015028e9.png";